import React from "react";
import { Box, Container, Typography, Grid } from "@mui/material";
import { motion } from "framer-motion";

const legacyData = [
  {
    number: "8+",
    label: "Years of Excellence",
  },
  {
    number: "450+",
    label: "Projects Delivered",
  },
  {
    number: "₹20M+",
    label: "Property Transacted",
  },
  {
    number: "99%",
    label: "Client Satisfaction",
  },
];

const LegacyInNumberSection = () => {
  return (
    <Box
      sx={{
        width: "100%",
        bgcolor: "#1C1B1B",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        py: { xs: "64px", md: "96px" },
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Background Watermark "AB" */}
      <Typography
        sx={{
          position: "absolute",
          right: { xs: "-10px", md: "0px" },
          bottom: { xs: "-10px", md: "-20px" },
          width: { md: "386px" },
          height: { md: "300px" },
          fontFamily: "Inter, sans-serif",
          fontWeight: 900,
          fontSize: { xs: "180px", md: "300px" },
          color: "rgba(252, 249, 248, 0.05)", // Subtly light color with low opacity
          lineHeight: "300px",
          letterSpacing: "-15px",
          pointerEvents: "none",
          userSelect: "none",
          zIndex: 0,
          textAlign: "right",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
        }}
      >
        AB
      </Typography>

      <Box
        sx={{
          width: "100%",
          maxWidth: "1280px",
          px: { xs: "24px", md: "48px" },
          boxSizing: "border-box",
          position: "relative",
          zIndex: 1,
        }}
      >
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              sm: "repeat(2, 1fr)",
              md: "repeat(4, 1fr)",
            },
            columnGap: "32px",
            rowGap: "40px",
            width: "100%",
            maxWidth: "1184px",
            mx: "auto",
          }}
        >
          {legacyData.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
            >
              <Box
                sx={{
                  borderLeft: "1px solid rgba(252, 249, 248, 0.2)",
                  pl: "32px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  gap: "10px",
                  height: { xs: "auto", md: "84px" },
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "Manrope, sans-serif",
                    fontWeight: 700,
                    fontSize: { xs: "32px", md: "48px" },
                    lineHeight: "1",
                    color: "#FFFFFF",
                    letterSpacing: "-1px",
                  }}
                >
                  {item.number}
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Inter, sans-serif",
                    fontWeight: 500,
                    fontSize: "11px",
                    lineHeight: "1.2",
                    color: "rgba(255, 255, 255, 0.5)",
                    textTransform: "uppercase",
                    letterSpacing: "1.5px",
                  }}
                >
                  {item.label}
                </Typography>
              </Box>
            </motion.div>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default LegacyInNumberSection;
